import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip } from "chart.js";
import { PolarArea } from "react-chartjs-2";
import usePatientsStatusData from '../../hooks/patients/usePatientsStatusData';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip);

const PatientsStatusChart = () => {
  const {
    patientsChartData,
    getPatientsStatusData,
    patientsStatusLoading
  } = usePatientsStatusData();

  useEffect(() => {
    getPatientsStatusData();
  }, []);

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    maintainAspectRatio: true,
  };

  if (patientsStatusLoading) {
    return <div>Loading...</div>;
  }

  if (!patientsChartData) {
    return <div>No data available</div>;
  }

  return (
    <div style={{ width: '170px', height: '170px', margin: '0 auto' }}>
      <PolarArea data={patientsChartData} options={options} />
    </div>
  );
};

export default PatientsStatusChart;